import PropTypes from 'prop-types';
// material-ui
import { useTheme } from '@mui/material/styles';

// project imports
import { ThemeMode } from 'config';
import { getSiteBrand } from 'utils/environment';
import logo from 'assets/images/logo.png';
import logoDev from 'assets/images/logo-dev.png';
import logoTest from 'assets/images/logo-test.png';

const LOGO_BY_BRAND = { prod: logo, test: logoTest, dev: logoDev };

// ==============================|| LOGO SVG ||============================== //

export default function LogoMain({ reverse }) {
  const theme = useTheme();
  return (
    <img src={LOGO_BY_BRAND[getSiteBrand()]} alt="Logo" width="120px" style={{ objectFit: 'contain' }} />
  );
}

LogoMain.propTypes = { reverse: PropTypes.bool };
